import gql from 'graphql-tag';

/**
 * Query to fetch a single inspection instance with full detail including
 * responses and observations. Uses the inspectionInstances endpoint with
 * perPage:1 as a bridge until the inspectionInstance(id) resolver is
 * implemented server-side.
 *
 * Future swap: when inspectionInstance(id: UUID!) resolver is live,
 * replace this query body with the single-instance query and update
 * the variable mapping in useGetInspectionInstanceDetail — no other
 * changes needed.
 */
export const getInspectionInstanceDetailQuery = gql`
  query getInspectionInstanceDetail(
    $channelId: UUID!
    $search: InspectionInstanceSearchInput
  ) {
    inspectionInstances(
      channelId: $channelId
      search: $search
      pagination: { start: 0, perPage: 50 }
    ) {
      inspectionInstances {
        id
        schemaVersion
        version
        templateRef {
          templateId
          version
          templateName
        }
        metadata {
          buildingId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          tenantId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          suiteId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          assignedTo
          scheduledFor
          scheduleId
          createdAt
          createdBy
        }
        state {
          status
          startedAt
          completedAt
          completedBy
          closedReason
          lastPosition {
            sectionId
            itemId
          }
          progress {
            totalItems
            completedItems
            requiredItems
            completedRequiredItems
            sectionProgress {
              sectionId
              total
              completed
            }
          }
        }
        responses {
          itemId
          value
          notes
          additionalFields
          isDeficient
          serviceRequestId
          photos {
            id
            localPath
            remoteUrl
            thumbnailUrl
            uploadStatus
            metadata {
              capturedAt
              fileSize
              contentType
              caption
              location {
                latitude
                longitude
                accuracy
              }
              dimensions {
                width
                height
              }
            }
          }
          timestamps {
            createdAt
            updatedAt
            deviceTimestamp
          }
          syncState {
            status
            lastAttempt
            error
            retryCount
          }
        }
        observations {
          id
          sectionId
          description
          addedAt
          suggestAddToTemplate
          response {
            itemId
            value
            notes
            additionalFields
            isDeficient
            serviceRequestId
            photos {
              id
              localPath
              remoteUrl
              thumbnailUrl
              uploadStatus
              metadata {
                capturedAt
                fileSize
                contentType
                caption
                location {
                  latitude
                  longitude
                  accuracy
                }
                dimensions {
                  width
                  height
                }
              }
            }
            timestamps {
              createdAt
              updatedAt
              deviceTimestamp
            }
            syncState {
              status
              lastAttempt
              error
              retryCount
            }
          }
        }
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
